<div class="cookie-overlay" *ngIf="isVisible">
  <div class="cookie-banner">
    <div class="cookie-banner__content">
      <h2>Używamy plików cookie</h2>

      <p>
        Korzystamy z niezbędnych plików cookie, aby strona działała prawidłowo.
        Za Twoją zgodą użyjemy też plików analitycznych i marketingowych.
      </p>

      <ng-container *ngIf="!showSettings">
        <div class="cookie-banner__actions">
          <button type="button" class="primary" (click)="acceptAll()">
            Akceptuję
          </button>

          <button type="button" class="secondary" (click)="rejectAll()">
            Odrzucam
          </button>

          <button type="button" class="link" (click)="openSettings()">
            Dostosuj
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="showSettings">
        <div class="cookie-banner__settings">
          <label>
            <input type="checkbox" checked disabled />
            Niezbędne
          </label>

          <label>
            <input type="checkbox" [(ngModel)]="analytics" />
            Analityczne
          </label>

          <label>
            <input type="checkbox" [(ngModel)]="marketing" />
            Marketingowe
          </label>
        </div>

        <div class="cookie-banner__actions">
          <button type="button" class="primary" (click)="saveCustom()">
            Zapisz ustawienia
          </button>

          <button type="button" class="secondary" (click)="closeSettings()">
            Wróć
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
